<template>
	<div class="add_or_edit_topic">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">发布提交通知</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<el-form :model="addTopicForm" :rules="addTopicFormRules" ref="addTopicFormRef" label-width="100px" class="demo-addTopicForm">
											<el-form-item label="通知课题" prop="projectName"><el-input v-model="addTopicForm.projectName"></el-input></el-form-item>
											<el-form-item label="作品类型">
												<el-select v-model="addTopicForm.projectTypeId" placeholder="请选择" clearable>
													<el-option v-for="item in topicLevelOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item label="通知内容">
												<TinymceEditor @input="e => changeData2('note', e)" :value="addTopicForm.note" :baseUrl="uploadUrl"></TinymceEditor>
											</el-form-item>
											<el-form-item label="提交方式" prop="way">
												<el-radio v-model="addTopicForm.way" :label="1">教师自己上传</el-radio>
												<el-radio v-model="addTopicForm.way" :label="2">学校管理员上传</el-radio>
											</el-form-item>
											<el-form-item label="填写选项">
												<el-checkbox-group v-model="addTopicForm.ontherId" @change="changeBox">
													<el-checkbox v-for="(item, index) in fillInOptions" :key="index" :label="item.id" :disabled="index==0">{{ item.label }}</el-checkbox>
												</el-checkbox-group>
											</el-form-item>
											<el-form-item label="提交附件数量" prop="loadNumber">
												<el-select
													v-model="addTopicForm.loadNumber"
													:disabled="isDisabled"
													clearable
													placeholder="请选择"
													@change="changeNumber"
													@clear="clearNumber"
												>
													<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item :label="item.name" v-for="(item, index) in optionList" :key="index" prop="name">
												<el-input size="small" v-model="item.value" style="width: 218px;" class="input-wd" maxlength="20"></el-input>
												<el-checkbox v-model="item.isTrue">必填</el-checkbox>
											</el-form-item>
											<el-form-item label="教师限制数量" prop="magnitude">
												<div style="display: flex;">
													<el-input v-model="addTopicForm.magnitude" class="input-wd" maxlength="3"></el-input>
													<span>个</span>
												</div>
											</el-form-item>
											<el-form-item label="学校初审通过名额" prop="trialByNumber">
												<div style="display: flex;">
													<el-input v-model="addTopicForm.trialByNumber" class="input-wd" maxlength="3"></el-input>
													<span>个</span>
												</div>
											</el-form-item>
											<el-form-item label="主要参与者">
												<el-input v-model="addTopicForm.memberNumberLimit" class="input-wd"></el-input>
												<span>名</span>
											</el-form-item>
											<el-form-item label="上传截止时间" prop="declareEndTime">
												<el-date-picker
													v-model="addTopicForm.declareEndTime"
													value-format="yyyy-MM-dd HH:mm:ss"
													type="datetime"
													placeholder="选择日期时间"
												></el-date-picker>
											</el-form-item>
											<el-form-item label="初审截止时间" prop="trialEndTime">
												<el-date-picker
													v-model="addTopicForm.trialEndTime"
													value-format="yyyy-MM-dd HH:mm:ss"
													type="datetime"
													placeholder="选择日期时间"
												></el-date-picker>
											</el-form-item>
											<el-form-item label="通知附件" prop="annexId"><UploadFile @file-event="changeData('annexId', $event)" :value="annexId" /></el-form-item>
											<el-form-item label=" ">
												<el-button type="primary" @click="createTopic('addTopicForm')">保存</el-button>
												<el-button type="primary" @click="goBack">返回</el-button>
											</el-form-item>
										</el-form>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import UploadFile from '@/components/UploadFile.vue';
import { saveOrUpdate, getEduDictData, getReviewInfo } from '@/api/after/newInterface.js';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import TinymceEditor from '@/components/TinymceEditor.vue';
export default {
	components: {
		Breadcrumb,
		TinymceEditor,
		UploadFile
	},
	data() {
		var checkMagnitude = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请填写教师限制数量'));
			} else {
				if (this.inInteger(value)) {
					if (value > 0) {
						callback();
					} else {
						callback(new Error('请填写大于0的整数'));
					}
				} else {
					callback(new Error('请填写大于0的整数'));
				}
			}
		};
		return {
			isDisabled: false,
			annexId: {
				id: '',
				name: ''
			},
			checked: false,
			addTopicForm: {
				loadNumber: '',
				projectName: '',
				projectTypeId: null,
				note: '',
				way: '',
				ontherId: [0],
				memberNumberLimit: '',
				trialByNumber: '',
				declareEndTime: '',
				trialEndTime: '',
				annexId: '',
				annexNames: '',
				annexIds: '',
				type: 2,
				magnitude: ''
			},
			fillInOptions: [{ label: '学段', id: 0 }, { label: '学科', id: 1 }, { label: '关键词', id: 2 }, { label: '摘要/简介', id: 3 }, { label: '上传匿名评审文档', id: 4 }],
			options: [], //提交数量
			optionList: [],
			topicLevelOptions: [],
			addTopicFormRules: {
				projectName: [{ required: true, message: '请输出标题名称', trigger: 'blur' }],
				declareEndTime: [{ required: true, message: '请选择上传截止时间', trigger: 'change' }],
				trialEndTime: [{ required: true, message: '请选择初审截止时间', trigger: 'change' }],
				trialByNumber: [{ required: true, message: '请填写各学校数量', trigger: 'change' }],
				loadNumber: [{ required: true, message: '请选择提交附件数量', trigger: 'change' }],
				way: [{ required: true, message: '请选择提交方式', trigger: 'change' }],
				magnitude: [{ validator: checkMagnitude, trigger: 'blur' }]
			},
			ids: '',
			checkArr: []
		};
	},
	created() {
		this.getTree();
		this.ids = this.$route.query.id;
		if (this.ids) {
			this.addTopicForm.id = this.ids;
			this.getInfo();
		}
		for (let i = 0; i < 20; i++) {
			this.$set(this.options, i, {
				value: i + 1,
				label: i + 1
			});
		}
	},
	methods: {
		inInteger(val) {
			return Math.floor(val) == val;
		},
		changeBox(e) {
			this.checkArr = e;
		},
		getInfo() {
			getReviewInfo(this.ids).then(res => {
				if (res.code == 200) {
					this.addTopicForm = res.data;
					this.checkArr = this.addTopicForm.ontherId ? this.addTopicForm.ontherId.split(',').map(Number) : [];
					this.addTopicForm.ontherId = this.addTopicForm.ontherId ? this.addTopicForm.ontherId.split(',').map(Number) : [];
					this.addTopicForm.projectTypeId = Number(this.addTopicForm.projectTypeId);
					this.optionList = this.addTopicForm.eduAnnexNames;
					this.addTopicForm.loadNumber = this.addTopicForm.eduAnnexNames.length;
					this.isDisabled = this.addTopicForm.loadNumber ? true : false;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		getTree() {
			getEduDictData(12).then(res => {
				if (res.code == 200) {
					this.topicLevelOptions = res.data;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 提交附件数量
		clearNumber() {
			this.optionList = [];
		},
		//提交附件数量
		changeNumber(e) {
			this.optionList = [];
			for (let i = 0; i < e; i++) {
				this.$set(this.optionList, i, {
					name: `附件${i + 1}名称`,
					value: '',
					isTrue: false
				});
			}
		},
		//文件上传
		changeData(name, data) {
			this.addTopicForm.annexId = data.id;
			this.addTopicForm.annexName = data.name;
		},
		createTopic(formName) {
			this.$refs.addTopicFormRef.validate(async valid => {
				if (valid) {
					let isUplod = false;
					if (this.optionList.length > 0) {
						this.optionList.forEach(item => {
							this.$set(item, 'state', item.isTrue ? 1 : 0);
							if (!item.value) {
								this.$message.error(`请上传${item.name}的附件`);
								return (isUplod = true);
							}
						});
						if (isUplod) {
							return;
						}
						this.addTopicForm.annexNames = this.optionList.map(item => item.value).join(',');
						this.addTopicForm.annexIds = this.optionList.map(item => item.state).join(',');
					}
					this.addTopicForm.ontherId = this.checkArr ? this.checkArr.join(',') : '';
					saveOrUpdate(this.addTopicForm).then(res => {
						if (res.code == 200) {
							this.$message.success(res.msg);
							this.$router.go(-1);
						} else {
							this.$message.error(res.msg);
						}
					});
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		goBack() {
			this.$router.push({ path: '/backstage/districtManageAchievement' });
		},
		changeData2(name, data) {
			this.addTopicForm.note = data;
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-form-item__label {
	min-width: max-content;
}
.input-wd {
	width: 100px;
	margin-right: 10px;
}
</style>
